module.exports = __webpack_public_path__ + "img/header-11.626e582.webp";